export default {
  mounted() {
    if (document.domain === 'paciente.drconecta.com.br') {
      const page = String(document.location).split(document.domain)[1];

      window.gtag('config', 'UA-150272499-1', { 'page_path': page });
    }
  },
};
